import { useRef, useState } from "react";
import { IonContent, IonItem, IonModal, IonRadio, IonRadioGroup, IonSpinner } from "@ionic/react";
import { SchoolModel } from "model";
import { Colors } from "swing-components";

import { translate } from "~utils";

import { ModalHeader } from "../ModalHeader";
import { SelectItem } from "../SelectItem";

type SchoolFieldProps = {
  value: string;
  onChange: (schoolId: string) => void;
  /** Optional **/
  schools?: SchoolModel[];
  /**
   * TODO: This is active more of a read-only state, then a disabled state.
   * Review in the future.
   * @default false
   */
  isDisabled?: boolean;
};

export function SchoolField(props: SchoolFieldProps) {
  const { value, isDisabled, onChange, schools } = props;

  const modalRef = useRef<HTMLIonModalElement>(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [selected, setSelected] = useState(value);
  const label = schools?.find((school) => school.id === selected)?.name;

  const searchFilteredSchools = schools?.filter((school) =>
    school.name.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  const onModalDismiss = () => {
    setSelected(value);
    modalRef.current?.dismiss();
  };

  const onModalConfirm = () => {
    onChange(selected);
    modalRef.current?.dismiss();
  };

  return (
    <SelectItem
      id="school-select-modal"
      label={translate("SCHOOL_LABEL")}
      isRequired={!isDisabled}
      value={label}
      stacked
      isDisabled={isDisabled}
      css={isDisabled ? { color: Colors.slate300, cursor: "not-allowed" } : undefined}
    >
      <IonModal
        aria-label={translate("SCHOOL_MODAL_HEADER")}
        trigger="school-select-modal"
        ref={modalRef}
        backdropDismiss={false}
      >
        <ModalHeader
          title={translate("SCHOOL_MODAL_HEADER")}
          onModalDismiss={onModalDismiss}
          onModalConfirm={onModalConfirm}
          onIonInput={(e) => setSearchTerm(e?.target?.value || "")}
        />
        <IonContent>
          {!searchFilteredSchools ? (
            <div className="flex justify-center mt-4">
              <IonSpinner name="dots" />
            </div>
          ) : (
            <IonRadioGroup value={selected} onIonChange={(e) => setSelected(e.target.value)}>
              {searchFilteredSchools.map((school, idx) => {
                return (
                  <IonItem key={idx}>
                    <IonRadio value={school.id} justify="start" labelPlacement="end">
                      {school.name}
                    </IonRadio>
                  </IonItem>
                );
              })}
            </IonRadioGroup>
          )}
        </IonContent>
      </IonModal>
    </SelectItem>
  );
}
